import { t } from '@lingui/core/macro';

/**
 * Error translations for the admin api errors and other
 * generic errors through the application.
 */
export function getErrorTranslations() {
  return {
    /**
     * Generic errors
     */
    generic: {
      title: t`Error`,
      message: t`Something went wrong. Please try again.`,
    },

    /**
     * TRPC Errors
     */
    SUBSCRIPTION_LIMIT_REACHED: {
      title: t`Limit Exceeded`,
      message: t`You have exceeded the subscription usage limits.`,
    },
    USER_DELETE_SELF: {
      title: t`Cannot Delete User`,
      message: t`Cannot delete yourself.`,
    },
    USER_DELETE_MULTIPLE_ORGANIZATIONS: {
      title: t`Cannot Delete User`,
      message: t`Cannot delete a user who belongs to multiple organizations.`,
    },
    ORGANIZATION_DELETE_SINGLE_USER_ORGANIZATION: {
      title: t`Cannot Delete Organization`,
      message: t`Cannot delete an organization that has users that belongs only to this organization Delete the users first.`,
    },
    USER_REMOVE_LAST_ORGANIZATION: {
      title: t`Cannot Remove User`,
      message: t`Cannot remove a user that belongs only to this organization.`,
    },
    ORGANIZATION_DELETE_LAST_ORGANIZATION: {
      title: t`Cannot Delete Organization`,
      message: t`You cannot delete your last organization.`,
    },

    /**
     * HTTP errors
     */
    '400': {
      title: t`Bad Request`,
      message: t`The request was not processed correctly.`,
    },
    '401': {
      title: t`Unauthorized Access`,
      message: t`You don't have access to this action.`,
    },
    '403': {
      title: t`Forbidden Access`,
      message: t`You don't have sufficient permissions for this action.`,
    },
    '404': {
      title: t`Not Found`,
      message: t`The requested record was not found.`,
    },
    '409': {
      title: t`Conflict`,
      message: t`A conflict occurred while processing data.`,
    },
    '413': {
      title: t`File Too Large`,
      message: t`File is too large. Maximum file size is {size} MB.`,
    },
    '429': {
      title: t`Too Many Requests`,
      message: t`Too many requests. Please try again later.`,
    },
    '500': {
      title: t`Server Error`,
      message: t`A server error occurred. Please try again later.`,
    },
  } as const;
}
